import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { Tag } from "lucide-react";

export default function BlogRightSidebar() {
  const { isDark } = useTheme();

  return (
    <aside
      className={`w-72 border-l overflow-y-auto hide-scrollbar min-h-screen sticky top-0 h-screen hidden xl:block ${
        isDark ? "border-border-dark bg-background-dark" : "border-border/50"
      }`}
    >
      <div className="p-6">
        {/* Topics */}
        <div>
          <div className="flex items-center gap-2 mb-4">
            <h3
              className={`text-sm font-display font-semibold uppercase tracking-wider flex items-center gap-2 ${
                isDark ? "text-white" : "text-text"
              }`}
            >
              <Tag
                size={16}
                className={isDark ? "text-primary-dark" : "text-primary"}
              />
              Topics
            </h3>
          </div>
          <div className="flex flex-wrap gap-2.5">
            {[
              "Backend",
              "DevOps",
              "DSA",
              "Performance",
              "Linux",
              "Cloud",
              "CI/CD",
              "Infrastructure",
              "Web",
              "Theory",
              "Docker",
              "Kubernetes",
              "SystemDesign",
              "Architecture",
              "Networking",
              "Automation",
              "Rust",
            ].map((tag, index) => (
              <Link
                key={index}
                to={`/tags/${tag.toLowerCase().replace(/\//g, "-")}`}
                className={`px-3 py-2 text-xs border rounded-lg transition-all duration-base ${
                  isDark
                    ? "text-gray-400 hover:text-white border-border-dark hover:border-primary-dark/50 hover:bg-border-dark"
                    : "text-text-muted hover:text-text border-border/50 hover:border-primary/50 hover:bg-secondary/20"
                }`}
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}
